import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const NAV_ITEMS = [
  { id: 'about', label: 'About' },
  { id: 'services', label: 'What We Do' },
  { id: 'process', label: 'Our Process' },
  { id: 'programs', label: 'Programs' },
  { id: 'testimonials', label: 'Testimonials' },
];

const WHATSAPP_URL = 'https://wa.me/919766144233';
const LOGO_SRC = 'https://customer-assets.emergentagent.com/job_c7ce965f-b752-41cd-938a-aad5b5cd43c6/artifacts/k82ysdfv_Arogya%20Vitalis%20with%20Tagline.png';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/70 backdrop-blur-xl border-b border-white/40' : 'bg-white/95 backdrop-blur-sm'
      }`}
      style={{ boxShadow: isScrolled ? '0 4px 24px rgba(75, 46, 93, 0.06)' : 'none' }}
      data-testid="main-navigation"
    >
      <div className="container-custom">
        <div className="flex items-center justify-between" style={{ height: '80px' }}>
          <div className="flex items-center">
            <img src={LOGO_SRC} alt="Arogya Vitalis" className="h-12 md:h-14" />
          </div>

          {/* Desktop Navigation */}
          <ul className="hidden lg:flex items-center gap-8 m-0 p-0 list-none">
            {NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  data-testid={`nav-link-${item.id}`}
                  className="text-sm font-medium transition-smooth hover:opacity-70"
                  style={{ color: 'var(--brand-charcoal)' }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="nav-book-consultation-btn">
              Book Consultation
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{ color: 'var(--brand-deep-plum)' }}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-6 border-t" style={{ borderColor: 'var(--brand-light-lavender)' }}>
            <ul className="flex flex-col gap-4 m-0 p-0 list-none">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    data-testid={`mobile-nav-link-${item.id}`}
                    className="text-base font-medium w-full text-left"
                    style={{ color: 'var(--brand-charcoal)' }}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
              <li className="pt-4">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-primary w-full">
                  Book Consultation
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};
